// Auto-generated by scripts/generate-registry.mjs from packages/modules/ai_e27_design_demo/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const ai_e27_design_demo: ModuleSchema = {
  "id": "ai_e27_design_demo",
  "uniqueId": "B3D_FIP9W",
  "createdAt": "2026-10-22T15:17:10.600Z",
  "updatedAt": "2026-10-28T14:57:47.705Z",
  "label": "E27 Design Demo",
  "description": "Prototype lamp constrained to the E27_V1 interface. Visual dimensions can change; socket, cavity, cable exit, and shade hole remain fixed.",
  "category": "lighting",
  "tags": [
    "ai-designer",
    "e27",
    "prototype",
    "lamp"
  ],
  "sliders": [
    {
      "key": "baseDiameter",
      "label": "Base diameter",
      "min": 80,
      "max": 180,
      "default": 110,
      "step": 1,
      "unit": "mm",
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "baseHeight",
      "label": "Base height",
      "min": 60,
      "max": 140,
      "default": 100,
      "step": 1,
      "unit": "mm",
      "targetGroupIds": [
        0,
        1
      ]
    },
    {
      "key": "shadeDiameter",
      "label": "Shade diameter",
      "min": 100,
      "max": 240,
      "default": 180,
      "step": 1,
      "unit": "mm",
      "targetGroupIds": [
        1
      ]
    },
    {
      "key": "shadeHeight",
      "label": "Shade height",
      "min": 80,
      "max": 220,
      "default": 150,
      "step": 1,
      "unit": "mm",
      "targetGroupIds": [
        1
      ]
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "e27_base",
      "label": "E27 base",
      "default": "#7c5a42",
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "e27_shade",
      "label": "E27 shade",
      "default": "#f5ead7",
      "targetGroupIds": [
        1
      ]
    }
  ],
  "objects": [
    {
      "id": "e27_base_object",
      "label": "E27 V1 Base",
      "name": "E27 V1 Base",
      "color": "#7c5a42",
      "assembled_z_offset": 0,
      "exploded_z_offset": 25,
      "parts": [
        {
          "id": "e27_base",
          "label": "E27 base",
          "name": "E27 base",
          "groupId": 0,
          "colorKey": "e27_base",
          "defaultColor": "#7c5a42",
          "assembled_z_offset": 0,
          "exploded_z_offset": 25,
          "export_stl": true
        }
      ]
    },
    {
      "id": "e27_shade_object",
      "label": "E27 V1 Shade",
      "name": "E27 V1 Shade",
      "color": "#f5ead7",
      "assembled_z_offset": 0,
      "exploded_z_offset": 60,
      "parts": [
        {
          "id": "e27_shade",
          "label": "E27 shade",
          "name": "E27 shade",
          "groupId": 1,
          "colorKey": "e27_shade",
          "defaultColor": "#f5ead7",
          "assembled_z_offset": 0,
          "exploded_z_offset": 60,
          "export_stl": true
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "id": "all",
      "label": "Download STL - full lamp"
    },
    {
      "id": "base",
      "label": "Download STL - base",
      "groupId": 0
    },
    {
      "id": "shade",
      "label": "Download STL - shade",
      "groupId": 1
    }
  ]
};
